// @flow

import { fork, all } from 'redux-saga/effects';
import { authSaga, chatSaga } from 'core/modules';

export default function* rootSaga() {
  yield all([fork(authSaga), fork(chatSaga)]);
}
